import { useMutation } from 'react-query'

import { vectorStoreService } from 'src/services/vector-store.service'

export const useUpdateVectorStoreData = () => {
  return useMutation(async () => vectorStoreService.updateStoreData(), {
    onSuccess() {},
  })
}
